<!-- Desktop list row, node 3499:100703: 56px avatar, 18px text, 8px gap between rows. -->
<div class="list-wrapper flex flex-col gap-2">
  @for (member of list(); track member.public_id) {
    <div class="flex items-center gap-4 p-2">
      <app-user-avatar [size]="56" [avatarUrl]="getAvatarUrl(member)" [initials]="getInitials(member)" />
      <div class="flex flex-1 items-center gap-4 min-w-0">
        <div class="flex flex-1 flex-col gap-2 min-w-0">
          <div class="color-neutral-800 text-[1.125rem]/[1.6] font-medium truncate">{{ member.full_name }}</div>
          <div class="color-neutral-500 text-[1.125rem]/[1.6]">
            {{ member.leaves | number: '1.0-0' : language() }} {{ 'myGanarbols.leaves' | translate }} |
            {{ member.community_size | number: '1.0-0' : language() }} {{ 'balance.community' | translate }}
          </div>
        </div>
        <div class="color-neutral-800 text-[1.125rem]/[1.6] whitespace-nowrap">
          {{ member.contribution | balanceMoney }}
        </div>
      </div>
    </div>
  }
</div>
